import { isCurrencyHidden } from "./login-params";

export function displayCurrency(currencyCode) {
  if (isCurrencyHidden || currencyCode == null || currencyCode === "") {
    return "";
  }

  return currencyCode === "ETBB" ? "ETB" : currencyCode;
}

export function amountWithCurrency(amount, currencyCode) {
  const currency = displayCurrency(currencyCode);
  return currency ? `${amount} ${currency}` : `${amount}`;
}
